/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-var: 0 */
/* globals _, Backbone, mixpanel, mp */

const {getCookie} = require(`common/util/cookie`);
var signup_form_tpl = require(`./templates/signup_form.pug`);

_.namespace(`Backbone.widgets`, function(ns) {
  "use strict";

  var SignupForm = Backbone.Form.extend({
    templates: _.extend({}, Backbone.Form.prototype.templates, {
      base: signup_form_tpl,
    }),

    endpoint: `/register_ajax/`,

    initialize(options) {
      this.$overlay = options.$overlay;
      this.purchase_flow = options.purchase_flow;
      this.tooltips = [];
      this.source = options.source;
      this.step_source = options.step_source;
      this.plan = options.plan;
      this.url = options.url;
      Backbone.Form.prototype.initialize.apply(this, arguments);
    },

    render_base_template(context) {
      this.$form = $(this.templates.base());
      this.$el.html(this.$form);
    },

    render() {
      this.$step = this.$overlay.find(`.step.signup`);
      this.render_base_template();
      this.$step.find(`.form-container`).html(this.$el);
      this.$overlay.find(`.step.signup`).show();

      this.delegateEvents({
        'input input': `_handle_input_change`,
        'submit form': `_handle_submit`,
        'click .exit': `hide`,
        'click .continue-signup': `validate_step_one`,
        'click .signup-back-button'() {
          if (this.$(`.step-1`).is(`:visible`)) {
            this.trigger(`back`);
          } else {
            this.$(`.step-2`).hide();
            this.$(`.step-1`).show();
            this.$(`.step-1`).find(`input`).first().focus();
            this.redirect_enter();
          }
        },
      });

      this.employee_choices = [
        `1`,
        `2-10`,
        `11-50`,
        `51-200`,
        `201-500`,
        `501-1,000`,
        `1,001-5,000`,
        `5,001-10,000`,
        `10,001+`,
      ];

      var mapped_employee_choices = _.map(this.employee_choices, function(value, i) {
        return [(i + 1).toString(), value];
      });

      this.employee_dropdown = new mp.widgets.dropdowns.Rounded().create(
        this.$form.find(`#employee-count`),
        mapped_employee_choices
      );

      var employee_field = this.$form.find(`.input.number_of_employees-input`);

      this.employee_dropdown.onchange(function(item) {
        employee_field.attr(`value`, item.value);
      });

      this.employee_dropdown.body.label_changed = function(ev, label) {
        this.container.css(`min-width`, label.container.outerWidth());
      };

      var opt_email_checkbox = $(`.opt-email-input`);
      $(`.opt-email-label`).click(function() {

        if (opt_email_checkbox.is(`:checked`)) {
          opt_email_checkbox.prop(`checked`, false);
        } else {
          opt_email_checkbox.prop(`checked`, true);
        }
      });
    },

    validate_step_one() {
      var errors = [];
      var $form = this.$form;
      _.each([`.name-input`, `.email-input`, `.password1-input`], function(selector) {
        var $el = $form.find(selector);
        var el = $el[0];

        // TODO ldb validate name & password, make sure email doesn't exist
        if (el.checkValidity && !el.checkValidity()) {
          errors.push({el: $el, error: `This field must be valid.`});
        } else if (!$el.val()) {
          errors.push({el: $el, error: `This field is required.`});
        } else if (selector === `.email-input` && !mp.utility.is_valid_email($el.val())) {
          errors.push({el: $el, error: `Please enter a valid email address`});
        }
      });

      if (errors && errors.length > 0) {
        this.trigger(`validation_error`, errors);

        if (!this.options.disable_tooltips) {
          this.show_tooltip(errors);
          this.reenable();
        }
      } else {
        this.$(`.step-1`).hide();
        this.$(`.step-2`).show();
        this.allow_enter();
        this.$(`.step-2`).find(`input`).first().focus();
        mixpanel.track(`Signup Page 2 Opened`);
      }
    },

    validate_element(form_element, form_data) {
      if (form_element.required_field === `required` && !form_element.val) {
        return `Please enter your ` + form_element.display;
      }

      if (form_element.name === `email` && !mp.utility.is_valid_email(form_element.val)) {
        return `Please enter a valid email address`;
      }
    },

    _get_form_data() {
      var fields = [
        `name`,
        `email`,
        `password1`,
        `company`,
        `phone`,
        `number_of_employees`,
        `Email_Opt_In__c`,
      ];

      var data = _.map(fields, function(field) {
        var $el = this.$(`input.` + field + `-input`);
        return {
          el: $el,
          val: $el.val(),
          name: field,
          display: $el.attr(`display`),
          required_field: $el.data(`required_field`),
          type: $el.attr(`type`) === `checkbox` ? `checkbox` : `inputbox`,
        };
      }, this);

      if (this.plan) {
        data.push({name: `plan_name`, val: this.plan.name});
      }
      data.push({name: `signup_url`, val: this.url});

      return data;
    },

    loading_state() {
      this.$(`button.purchase`)
        .addClass(`loading`)
        .attr(`disabled`, true);
      this.trigger(`form_submitted`);
    },

    loaded_state() {
      this.$(`button.purchase`)
        .removeClass(`loading`)
        .attr(`disabled`, false);
    },

    make_request(form_data) {
      var csrf = getCookie(`csrftoken`);
      var request_data = {};
      _.each(form_data, function(spec) {
        request_data[spec.name] = spec.val;
      });

      $.ajax(this.endpoint, {
        type: `POST`,
        data: request_data,
        dataType: `json`,
        headers: {
          'X-CSRFToken': csrf,
        },
        success: _.bind(function(response) {
          response = JSON.parse(response);
          if (response.status_text === `error`) {
            // if any errors in step 1, show those first
            this.$(`.step-2`).hide();
            this.$(`.step-1`).show();
            this.redirect_enter();
            var errors = JSON.parse(response.errors);
            var tooltip_errors = _.map(errors, function(error, element) {
              return {
                el: $(`input.` + element + `-input`),
                error: error[0].message,
              };
            });
            this.trigger(`validation_error`, tooltip_errors);

            if (!this.options.disable_tooltips) {
              this.show_tooltip(tooltip_errors);
              this.reenable();
            }
          } else {
            var employee_value = this.$form.find(`.input.number_of_employees-input`).val();
            var employees = employee_value ? this.employee_choices[employee_value - 1] + ` employees` : `N/A`;
            mp.utility.track_ga(`send`, `event`, `Inquiry`, `Sign up`, employees);
            mixpanel.track(`Sign Up`, {
              'Source': this.source,
              'Employees': employees,
            });

            var redirect_url = response.redirect_url;
            this.purchase_flow.handle_signup_continue(redirect_url);
          }
        }, this),
      });
    },

    _save() {
      var form_data = this._get_form_data();
      var errors = this._validate(form_data);
      const adblocked_distinct_id = `adblocked_${Math.random().toString(16).replace(`.`, ``)}`;

      form_data.push({
        name: `distinct_id`,
        val: mixpanel.get_distinct_id ? mixpanel.get_distinct_id() : adblocked_distinct_id,
      });

      form_data.push({
        name: `extras`,
        val: JSON.stringify({
          Last_Touch_Medium__c: getCookie(`mixpanel_utm_medium`),
          Last_Touch_Source__c: getCookie(`mixpanel_utm_source`),
          Last_Touch_Campaign__c: getCookie(`mixpanel_utm_campaign`),
          Last_Touch_Content__c: getCookie(`mixpanel_utm_content`),
          Last_Touch_Keyword__c: getCookie(`mixpanel_utm_term`),
          Last_Touch_Webpage__c: getCookie(`mp_Last_Touch_Webpage__c`),
          Last_Touch_Test_Variant__c: getCookie(`mp_Last_Touch_Test_Variant__c`),
          Last_Touch_Test_ID__c: getCookie(`mp_Last_Touch_Test_ID__c`),
          Last_Touch_Ad_Variant__c: getCookie(`mp_Last_Touch_Ad_Variant__c`),
        }),
      });

      if (errors && errors.length > 0) {
        this.trigger(`validation_error`, errors);

        if (!this.options.disable_tooltips) {
          this.show_tooltip(errors);
          this.reenable();
        }
      } else {
        this.loading_state();
        this.make_request(form_data);
      }
    },

    show_tooltip(fields) {
      this.remove_tooltip();
      var step_1 = false;

      _.each(fields, function(field) {
        var current_tooltip = $(this.render_template(`tooltip`, field));
        this.tooltips.push(current_tooltip);

        if (field.el) {
          if (this.$(`.step-1`).find(field.el)) {
            step_1 = true;
          }

          field.el.parent().append(current_tooltip);

          current_tooltip.hide();
          var tooltipWidth = current_tooltip.outerWidth();
          current_tooltip.css({
            'width': tooltipWidth,
          });
          current_tooltip.find(`.arrow`).css({
            'left': tooltipWidth / 2,
          });

          current_tooltip.css(`display`, `block`);
          field.el.addClass(`error`);
        }
      }, this);

      if (step_1) {
        // if any errors in step 1, show those first
        this.$(`.step-2`).hide();
        this.$(`.step-1`).show();
        this.redirect_enter();
      }
    },

    remove_tooltip() {
      _.each(this.tooltips, function(tooltip) {
        tooltip.remove();
      });
      this.$(`.input`).removeClass(`error`);
    },

    _handle_input_change(evt) {
      this.remove_tooltip_for_input(this.tooltips, evt.target);
    },

    redirect_enter() {
      $(`body`).on(`keydown.signup`, function(ev) {
        if (ev.which === 13) {
          ev.preventDefault();
          $(`.continue-signup`).trigger(`click`);
          return false;
        }
      });
    },

    allow_enter() {
      $(`body`).off(`keydown.signup`);
    },

    show(email, not_bind_esc) {
      $(`.email-input`).val(email);
      this.$overlay.show();
      this.$overlay.find(`.step`).hide();
      this.$step.show();

      if (!not_bind_esc) {
        mp.utility.bind_esc(this.cid, this.hide, this);
      }

      this.$(`.step-2`).hide();
      this.$(`.step-1`).show();
      this.$(`.step-1`).find(`input`).first().focus();
      this.redirect_enter();

      mixpanel.track(`Signup Opened`, {
        source: this.step_source,
      });
    },

    hide_back_button() {
      $(`.signup-back-button`).css(`display`, `none`);
    },

    hide() {
      this.$step.hide();
      this.$overlay.hide();
      mp.utility.unbind_esc(this.cid);

      mixpanel.track(`Signup Closed`, {
        source: this.step_source,
      });
    },
  });

  return {
    SignupForm,
  };
});

}.call(window));